import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    backgroundColor: theme.palette.info.main,
  },
}));

export default () => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center">
      <Card className={classes.root}>
        <CardContent>
          <Typography align="center" variant="h5" component="h2">
            Loading Drops ... :(
          </Typography>
          <Typography align="center" variant="body2" component="p">
            ROTMG Drops is updating.
          </Typography>
          <Typography align="center" variant="body2" component="p">
            This happens everyday for the first user.
          </Typography>
          <Typography align="center" variant="body2" component="p">
            Please wait a few seconds. Thanks.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
